import { Badge } from "@/components/ui/badge"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"

interface MetricCardProps {
  title: string
  value: number
  type: "week" | "activities"
  diff?: number
}

export default function MetricCard({ title, type, value, diff }: MetricCardProps) {
  // Handle NaN values by defaulting to 0
  const safeValue = isNaN(value) ? 0 : value
  const diffValue = isNaN(diff ?? 0) ? 0 : (diff ?? 0)

  const formatDiff = () => {
    const percentage = diffValue * 100
    const formattedPercentage = Math.round(percentage)
    if (percentage === 0) return "0% sem.pasada"
    return `${percentage > 0 ? "+" : ""} ${formattedPercentage}% sem.pasada`
  }
  const variant = diffValue === 0 ? "warning" : diffValue > 0 ? "default" : "destructive"

  const iconByType = {
    week: "📈",
    activities: "🎓",
  }[type]

  const labelByType = {
    week: safeValue + "%",
    activities: safeValue,
  }[type]

  return (
    <Card className="flex size-full min-h-[120px] min-w-[120px] flex-col border-none lg:min-h-[162px] lg:min-w-[200px]">
      <CardHeader>
        <CardTitle className="text-sm font-semibold text-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-1 items-center gap-2">
        <span className="text-2xl">{iconByType}</span>
        <h2 className="text-2xl font-bold text-foreground">{labelByType}</h2>
      </CardContent>
      {diff !== null && (
        <CardFooter>
          <Badge variant={variant} className="w-fit">
            {formatDiff()}
          </Badge>
        </CardFooter>
      )}
    </Card>
  )
}
